module.exports = __webpack_public_path__ + "static/media/buxton-11.381f64c5.jpg";